import React from "react";
import { Row, Col, Form } from "react-bootstrap";

const ExpressCargoFields = ({
  params,
  errors,
  onChange,
  calculator,
  tax,
  valuation,
}) => {
  return (
    <Row>
      <Col>
        <Form.Group>
          <Form.Label>Declared Value</Form.Label>
          <Form.Control
            type="number"
            name="declaredValue"
            value={params.declaredValue}
            onChange={onChange}
            placeholder="Enter Value"
            isInvalid={errors.declaredValue}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Valuation {calculator.valuationPercent} %</Form.Label>
          <Form.Control
            name="valuation"
            type="number"
            value={valuation}
            disabled
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Tax {calculator.taxPercent} %</Form.Label>
          <Form.Control name="tax" type="number" value={tax} disabled />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default ExpressCargoFields;
